import { addWeeks, endOfIsoWeek, startOfDay, subWeeks } from './dates';

const MINIMUM_NUMBER_WEEKS = 6;
const THURSDAY = 4;
const SUNDAY = 0;

export const getStartDate = (startDate: Date, endDate: Date): Date => {
	const minStartDate = startOfDay(subWeeks(endDate, MINIMUM_NUMBER_WEEKS));
	return startDate > minStartDate ? minStartDate : startDate;
};

// deployment labels are sometimes cut off towards the end of the week especially after Thursday
// resolve this issue by adding an extra week if day is after Thursday
const shouldAddExtraWeek = (endDate: Date): boolean =>
	endDate.getDay() > THURSDAY || endDate.getDay() === SUNDAY;

export const getEndDate = (endDate: Date): Date =>
	shouldAddExtraWeek(endDate) ? endOfIsoWeek(addWeeks(endDate, 1)) : endOfIsoWeek(endDate);

type TimeWindowFilter = {
	after: Date;
	before: Date;
};

type TimelineDuration = {
	startDate: Date;
	endDate: Date;
};

export const getTimelineDurationFromTimeWindowFilter = (
	timeWindowFilter: TimeWindowFilter,
): TimelineDuration => ({
	startDate: getStartDate(timeWindowFilter.after, timeWindowFilter.before),
	endDate: getEndDate(timeWindowFilter.before),
});
